import { render } from "./ModalV2.vue?vue&type=template&id=6f4b4932"
import script from "./ModalV2.vue?vue&type=script&lang=js"
export * from "./ModalV2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__